'use client';

import { Image } from '@sitecore-jss/sitecore-jss-react';
import OffersHero from './Hero/OldOffersHero';
import OffersAchieving from './Achieving/OffersAchieving';

export default function OffersList({ fields }) {
  // 从Sitecore fields获取数据
  const heroTitle = fields?.heroTitle?.value || fields?.heroTitle || '';
  const heroImage = fields?.heroImage;
  const blockTitle = fields?.blockTitle?.value || fields?.blockTitle || '';
  const blockText = fields?.blockText?.value || fields?.blockText || '';
  const items = fields?.items || [];

  return (
    <div className="container">
      <OffersHero heroTitle={heroTitle} heroImage={heroImage} />
      <OffersAchieving blockTitle={blockTitle} blockText={blockText} items={items} />
    </div>
  );
}
